module.exports = __webpack_public_path__ + "img/icon_sportMenu_waterpolo.e6a7e7a8.svg";